import React from 'react';
import { EXTRA_SERVICES_PRICE_TYPES } from '../../constants';

export function useOrderRecapTotalPrice(
  availableExtraServices,
  selectedExtraServices,
  productPrice
) {
  return React.useMemo(() => {
    if (availableExtraServices && productPrice && selectedExtraServices) {
      return availableExtraServices.reduce((acc, axs) => {
        const isGroup = axs.price_type === EXTRA_SERVICES_PRICE_TYPES.GROUP;
        const selectedExtraService = selectedExtraServices[axs.id];
        if (!selectedExtraService || !selectedExtraService.status) {
          return acc;
        }
        acc += isGroup ? axs.price : axs.price * selectedExtraService.status;
        return acc;
      }, productPrice);
    } else {
      return 0;
    }
  }, [availableExtraServices, productPrice, selectedExtraServices]);
}
